export default __webpack_public_path__ + "static/media/changeThumbnailIcon.e1c1efef.svg";